export const GET_OTP_DATA_SUCCESS = 'GET_OTP_DATA_SUCCESS'
export const CLEAR_OTP_DATA_SUCCESS = 'CLEAR_OTP_DATA_SUCCESS'